import { PageWithBreadcrumb } from '@components/Layouts'
import { MaterialGrid } from '@components/PageTitle/styles'
import styled from '@emotion/styled'
import { CUSTOM_SCROLLBAR } from '@helpers/styles'
import { Select, StepConnector, type Theme, Typography } from '@mui/material'
import { Button, Stepper } from '@mui/material'

const Title = styled.h2`
	${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.text.primary};
    `}
	font-size: 1.25rem;
	margin-top: 0;
	font-weight: 400;
`

const Subtitle = styled.p`
	${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.text.secondary};
    `}
	font-size: 0.875rem;
	line-height: 1rem;
	padding-top: 0px;
	padding-bottom: 0px;
`

const HelpText = styled.p`
	${({ theme }: { theme: Theme }) => `
		color: ${theme.palette.text.disabled};
	`}
	font-size: 0.875rem;
	font-weight: 500;
	display: flex;
	align-items: center;
`

const Header = styled.h3`
	${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.text.primary};
    `}
	font-size: 1rem;
	line-height: 1.25rem;
	font-weight: 400;
`

const Text = styled.p`
	${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.text.primary};
    `}
	font-size: 0.875rem;
`

const CenteredContainer = styled.div`
	padding: 1rem;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	padding: 0 264px 2rem;
`

const SectionContainer = styled.div`
	width: 100%;
`

const BorderedSection = styled(MaterialGrid)`
	${({ theme }: { theme: Theme }) => `
        border: 1px solid ${theme.palette.borderColors.darkGray};
    `}
	padding: 1rem;
	margin-top: 1rem;
	border-radius: 4px;
`

const FlexColumn = styled.div`
	flex-direction: column;
`

const StyledConnector = styled(StepConnector)`
	&.MuiStepConnector-vertical {
		padding-bottom: 0;
	}
	.MuiStepConnector-line {
		height: ${({ theme }: { theme: Theme }) => theme.spacing(4.625)};
	}
	&.Mui-active .MuiStepConnector-line,
	&.Mui-completed .MuiStepConnector-line {
		border-color: ${({ theme }: { theme: Theme }) =>
			theme.palette.emissionTypes.co2};
	}
`

const StyledSelect = styled(Select)`
	.MuiSelect-select {
		padding-top: 8px;
		padding-bottom: 8px;
	}
`

const Label = styled(Typography)`
	${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.text.secondary};
    `}
	line-height: 1rem;
	padding-top: 0px;
	padding-bottom: 0px;
`

const StyledStepper = styled(Stepper)`
	background-color: transparent !important;
	padding: 0 !important;
	position: sticky;
	top: 0;
`

const StyledPageWithBreadcrumb = styled(PageWithBreadcrumb)`
	display: flex;
	flex-direction: column;
	height: 95vh;
	padding: 1rem;
	paddingtop: 0;
	paddingbottom: 2rem;
	overflow-y: scroll;

	${CUSTOM_SCROLLBAR.scrollbarCustomVertical}
`

const BackButton = styled(Button)`
	:disabled {
		visibility: hidden;
	}
`

const ActionsContainer = styled.div`
	margin-top: ${({ theme }: { theme: Theme }) => theme.spacing(3)};
	margin-bottom: ${({ theme }: { theme: Theme }) => theme.spacing(2)};
	display: flex;
	justify-content: space-between;
	width: 100%;
`

export {
	ActionsContainer,
	BackButton,
	BorderedSection,
	CenteredContainer,
	FlexColumn,
	Header,
	HelpText,
	Label,
	SectionContainer,
	StyledConnector,
	StyledPageWithBreadcrumb,
	StyledSelect,
	StyledStepper,
	Subtitle,
	Text,
	Title,
}
